import { ConfigProviderProps } from "antd";

import { SpecificationColors } from "../specification";

/**
 * antd 主题 token
 */
export const PrimaryTheme: ConfigProviderProps["theme"] = {
  token: {
    // primary
    colorPrimaryHover: SpecificationColors["primary-4"],
    colorPrimary: SpecificationColors["primary-5"],
    colorPrimaryActive: SpecificationColors["primary-6"],
    colorPrimaryBg: SpecificationColors["primary-1"],
    colorPrimaryBgHover: SpecificationColors["primary-2"],
    colorPrimaryBorder: SpecificationColors["primary-3"],
    colorPrimaryBorderHover: SpecificationColors["primary-4"],
    colorPrimaryTextHover: SpecificationColors["primary-5"],
    colorPrimaryText: SpecificationColors["primary-6"],
    colorPrimaryTextActive: SpecificationColors["primary-7"],

    // link
    colorLink: SpecificationColors["primary-6"],
    colorLinkHover: SpecificationColors["primary-5"],
    colorLinkActive: SpecificationColors["primary-7"],

    // success
    colorSuccessHover: SpecificationColors["green-4"],
    colorSuccess: SpecificationColors["green-5"],
    colorSuccessActive: SpecificationColors["green-6"],
    colorSuccessBg: SpecificationColors["green-1"],
    colorSuccessBgHover: SpecificationColors["green-2"],
    colorSuccessBorder: SpecificationColors["green-3"],
    colorSuccessBorderHover: SpecificationColors["green-4"],
    colorSuccessTextHover: SpecificationColors["green-5"],
    colorSuccessText: SpecificationColors["green-6"],
    colorSuccessTextActive: SpecificationColors["green-7"],

    // warning
    colorWarningHover: SpecificationColors["yellow-3"],
    colorWarningBgHover: SpecificationColors["yellow-2"],
    colorWarningBorder: SpecificationColors["yellow-3"],
    colorWarningBorderHover: SpecificationColors["yellow-4"],
    colorWarningTextHover: SpecificationColors["yellow-5"],
    colorWarningTextActive: SpecificationColors["yellow-6"],

    // text
    colorText: SpecificationColors["opacity-88"],
    colorTextSecondary: SpecificationColors["opacity-65"],
    colorTextTertiary: SpecificationColors["opacity-45"],
    colorTextQuaternary: SpecificationColors["opacity-25"],

    // fill
    colorFill: SpecificationColors["opacity-15"],
    colorFillSecondary: SpecificationColors["opacity-6"],
    colorFillTertiary: SpecificationColors["opacity-4"],
    colorFillQuaternary: SpecificationColors["opacity-2"],

    // stroke
    colorBorder: SpecificationColors["gray-5"],
    colorBorderSecondary: SpecificationColors["gray-4"],

    // bg
    colorBgContainer: SpecificationColors["gray-1"],
    colorBgElevated: SpecificationColors["gray-1"],
    colorBgLayout: SpecificationColors["gray-3"],
    colorBgSpotlight: SpecificationColors["opacity-88"],
    colorBgMask: SpecificationColors["opacity-45"],

    // split
    colorSplit: SpecificationColors["opacity-6"],

    // info
    colorInfo: SpecificationColors["primary-5"],
  },
  components: {
    Button: {
      paddingInline: 20,
      paddingBlock: 7,
      paddingInlineLG: 22,
      paddingBlockLG: 10,
      paddingInlineSM: 16,
      paddingBlockSM: 5,
      borderRadius: 6,
      borderRadiusLG: 6,
      controlHeightLG: 36,
      controlHeight: 32,
      controlHeightSM: 28,
      contentFontSizeLG: 16,

      // 颜色
      colorBgContainerDisabled: SpecificationColors["gray-3"],
      colorTextDisabled: SpecificationColors["opacity-25"],
      borderColorDisabled: SpecificationColors["gray-5"],
      dangerColor: SpecificationColors["gray-1"],
      defaultActiveBg: SpecificationColors["gray-1"],
      defaultActiveBorderColor: SpecificationColors["primary-6"],
      defaultActiveColor: SpecificationColors["primary-6"],
      defaultBorderColor: SpecificationColors["gray-5"],
      defaultBg: SpecificationColors["gray-1"],
      defaultColor: SpecificationColors["opacity-65"],
      defaultGhostBorderColor: SpecificationColors["gray-1"],
      defaultHoverBg: SpecificationColors["gray-1"],
      ghostBg: "transparent",
      linkHoverBg: "transparent",
      primaryColor: SpecificationColors["gray-1"],
      solidTextColor: SpecificationColors["gray-1"],
      defaultHoverBorderColor: SpecificationColors["primary-4"],
      defaultHoverColor: SpecificationColors["primary-5"],
      textHoverBg: SpecificationColors["opacity-4"],
      textTextActiveColor: SpecificationColors["opacity-88"],
      textTextColor: SpecificationColors["opacity-88"],
      textTextHoverColor: SpecificationColors["opacity-88"],
    },
    Menu: {
      dangerItemActiveBg: SpecificationColors["red-2"],
      dangerItemColor: SpecificationColors["red-6"],
      dangerItemHoverColor: SpecificationColors["red-5"],
      dangerItemSelectedBg: SpecificationColors["red-1"],
      dangerItemSelectedColor: SpecificationColors["red-6"],
      horizontalItemHoverColor: SpecificationColors["primary-5"],
      horizontalItemSelectedColor: SpecificationColors["primary-6"],
      itemActiveBg: SpecificationColors["primary-1"],
      itemSelectedBg: SpecificationColors["primary-1"],
      itemSelectedColor: SpecificationColors["primary-6"],
      subMenuItemSelectedColor: SpecificationColors["primary-6"],
      itemHoverBg: SpecificationColors["opacity-6"],
      itemHoverColor: SpecificationColors["opacity-65"],
    },
    Pagination: {
      itemActiveBg: SpecificationColors["gray-1"],
      itemActiveBgDisabled: SpecificationColors["opacity-15"],
      itemActiveColorDisabled: SpecificationColors["opacity-25"],
      itemBg: SpecificationColors["gray-1"],
      itemInputBg: SpecificationColors["gray-1"],
      itemLinkBg: SpecificationColors["gray-1"],
    },

    // 数据录入
    Cascader: {
      optionSelectedBg: SpecificationColors["primary-1"],
      optionSelectedColor: SpecificationColors["primary-6"],
    },
    DatePicker: {
      activeBg: SpecificationColors["gray-1"],
      activeBorderColor: SpecificationColors["primary-5"],
      addonBg: SpecificationColors["opacity-2"],
      cellActiveWithRangeBg: SpecificationColors["primary-1"],
      cellBgDisabled: SpecificationColors["opacity-4"],
      cellHoverBg: SpecificationColors["opacity-4"],
      cellHoverWithRangeBg: SpecificationColors["primary-2"],
      cellRangeBorderColor: SpecificationColors["primary-3"],
      hoverBg: SpecificationColors["gray-1"],
      hoverBorderColor: SpecificationColors["primary-4"],
      multipleItemBg: SpecificationColors["opacity-6"],
      multipleItemBorderColor: "transparent",
      multipleItemBorderColorDisabled: "transparent",
      multipleItemColorDisabled: SpecificationColors["opacity-25"],
      multipleSelectorBgDisabled: SpecificationColors["opacity-4"],
    },
    Form: {
      labelColor: SpecificationColors["opacity-65"],
      labelRequiredMarkColor: SpecificationColors["red-6"],
    },
    Input: {
      activeBg: SpecificationColors["gray-1"],
      activeBorderColor: SpecificationColors["primary-5"],
      hoverBorderColor: SpecificationColors["primary-4"],
      addonBg: SpecificationColors["opacity-2"],
      hoverBg: SpecificationColors["gray-1"],
    },
    InputNumber: {
      activeBg: SpecificationColors["gray-1"],
      activeBorderColor: SpecificationColors["primary-5"],
      addonBg: SpecificationColors["opacity-4"],
      filledHandleBg: SpecificationColors["gray-4"],
      handleBorderColor: SpecificationColors["gray-5"],
      hoverBorderColor: SpecificationColors["primary-4"],
    },
    Mentions: {
      activeBg: SpecificationColors["gray-1"],
      activeBorderColor: SpecificationColors["primary-5"],
      addonBg: SpecificationColors["opacity-2"],
      hoverBg: SpecificationColors["gray-1"],
      hoverBorderColor: SpecificationColors["primary-4"],
    },
    Radio: {
      buttonBg: SpecificationColors["gray-1"],
      buttonCheckedBg: SpecificationColors["gray-1"],
      buttonCheckedBgDisabled: SpecificationColors["opacity-15"],
      buttonCheckedColorDisabled: SpecificationColors["opacity-25"],
      buttonSolidCheckedActiveBg: SpecificationColors["primary-6"],
      buttonSolidCheckedBg: SpecificationColors["primary-5"],
      buttonSolidCheckedHoverBg: SpecificationColors["primary-4"],
      dotColorDisabled: SpecificationColors["opacity-25"],
    },
    Select: {
      activeBorderColor: SpecificationColors["primary-5"],
      activeOutlineColor: SpecificationColors["primary-3"],
      clearBg: SpecificationColors["gray-1"],
      hoverBorderColor: SpecificationColors["primary-4"],
      multipleItemBg: SpecificationColors["opacity-6"],
      multipleItemBorderColor: "transparent",
      multipleItemBorderColorDisabled: "transparent",
      multipleItemColorDisabled: SpecificationColors["opacity-25"],
      multipleSelectorBgDisabled: SpecificationColors["opacity-4"],
      optionSelectedBg: SpecificationColors["primary-1"],
      optionSelectedColor: SpecificationColors["primary-6"],
      selectorBg: SpecificationColors["gray-1"],
    },
  },
};

/**
 * 黑色主题
 * - 目前支持 Button
 */
export const BlackTheme: ConfigProviderProps["theme"] = {
  token: {
    colorPrimaryHover: "#544F4C",
    colorPrimary: "#383533",
    colorPrimaryActive: "#282624",
    colorPrimaryBg: "#f6f5f5",
    colorPrimaryBgHover: "#e8e5e5",
    colorPrimaryBorder: "#d4cfcd",
    colorPrimaryBorderHover: "#b5adab",
    colorPrimaryTextHover: "#544F4C",
    colorPrimaryText: "#383533",
    colorPrimaryTextActive: "#282624",
    colorLinkHover: "#544F4C",
    colorLinkActive: "#282624",
  },
  components: {
    Button: {
      borderColorDisabled: "#d4cfcd",
      colorBgContainerDisabled: "#f6f5f5",
      colorTextDisabled: SpecificationColors["opacity-25"],
      dangerColor: SpecificationColors["gray-1"],
      defaultActiveBg: SpecificationColors["opacity-6"],
      defaultActiveBorderColor: "#282624",
      defaultActiveColor: "#282624",
      defaultBorderColor: "#383533",
      defaultBg: "transparent",
      defaultColor: "#383533",
      defaultGhostBorderColor: SpecificationColors["gray-1"],
      defaultHoverBg: SpecificationColors["opacity-4"],
      ghostBg: "transparent",
      linkHoverBg: "transparent",
      primaryColor: SpecificationColors["gray-1"],
      solidTextColor: SpecificationColors["gray-1"],
      defaultHoverBorderColor: "#544f4c",
      defaultHoverColor: "#544f4c",
      groupBorderColor: "#383533",
      textHoverBg: SpecificationColors["opacity-4"],
      textTextActiveColor: "#282624",
      textTextColor: "#383533",
      textTextHoverColor: "#282624",
    },
  },
};
